import Vue from "vue";
import store from "../store";
import { routes } from "./data";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  // eslint-disable-next-line no-console
  console.log(to)
  store.dispatch("system/CloseSideBar", to, { root: true });
  next();
});
// eslint-disable-next-line no-unused-vars
router.afterEach((to, from) => {});
export default router;
